import {LoaderCircle} from "lucide-react"
import {useState, Fragment} from "react"

export const Guide = () => {
  const [isLoadedGuidePage, setIsLoadedGuidePage] = useState<boolean>(false);
  const handleLoadGuidePage = () => {
    setIsLoadedGuidePage(true);
  }

  return (
      <Fragment>
        {
          !isLoadedGuidePage &&
            <div className="flex flex-shrink items-center justify-center sm:h-dvh md:h-36">
                <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
            </div>
        }
        <iframe
            style={{visibility: isLoadedGuidePage ? 'visible' : 'hidden'}}
            onLoad={handleLoadGuidePage} className="flex w-full h-full" src="https://guide.shortsworks.io" />
      </Fragment>
  );
};
